const Wpcf7 = () => {
  const $wpcf7 = $('.wpcf7-form')

  if ($wpcf7.find('.inputfile__container').length) {
    $wpcf7.find('.inputfile__container').each((_, el) => {
      const $container = $(el)
      const label = $container.data('label')
      const $input = $container.find('.inputfile__field')
      const id = $input.attr('id')
      const labelElement = `<label for="${id}"><i class="icon icon-download pr-3"></i><span>${label}</span></label>`
      $input.after(labelElement)
      $input.change((evt) => {
        const fileName = evt.target.value.split('\\').pop()
        $container.find('label span').html(fileName)
      })
    })
  }

  const clearLabel = () => {
    $wpcf7.find('.inputfile__container').each((_, el) => {
      const $container = $(el)
      const label = $container.data('label')
      const $label = $container.find('label')
      $label.find('span').html(label)
    })
  }

  if ($wpcf7.length && !$wpcf7.hasClass('wpcf7-form__contact')) {
    $wpcf7.submit((evt) => {
      const $form = $(evt.currentTarget)
      $form.find(':input[type=submit]').prop('disabled', true)
      const wpcf7Elm = document.querySelector('.wpcf7')
      wpcf7Elm.addEventListener('wpcf7submit', function () {
        jQuery('.wpcf7-submit').prop('disabled', false)
        clearLabel()
      }, false);
      wpcf7Elm.addEventListener('wpcf7invalid', function () {
        jQuery('.wpcf7-submit').prop('disabled', false);
      }, false);
    })
  }
}

export default Wpcf7



// WEBPACK FOOTER //
// ./scripts/components/Wpcf7.js